// doc: https://nhnent.github.io/tui.editor/api/latest/ToastUIEditor.html#ToastUIEditor
export default {
  previewStyle: "vertical",
  height: "600px",
  initialEditType: "markdown",
  previewStyle: "vertical",
  usageStatistics: false,
  initialValue: "Hello World!"
};
